import React from "react";

export default function() {
  return (
    <svg
      viewBox="64 64 896 896"
      width="1em"
      height="1em"
      fill="currentColor"
    >
      <defs>
        <style type="text/css"></style>
      </defs>
      <path
        d="M64 832m64 0l768 0q64 0 64 64l0 0q0 64-64 64l-768 0q-64 0-64-64l0 0q0-64 64-64Z"
        p-id="6718"
        fill=""
      ></path>
      <path
        d="M64 64m64 0l256 0q64 0 64 64l0 0q0 64-64 64l-256 0q-64 0-64-64l0 0q0-64 64-64Z"
        p-id="6719"
        fill=""
      ></path>
      <path
        d="M192 192h128v320a64 64 0 0 1-64 64 64 64 0 0 1-64-64V192z"
        p-id="6720"
        fill=""
      ></path>
      <path
        d="M576 64m64 0l256 0q64 0 64 64l0 0q0 64-64 64l-256 0q-64 0-64-64l0 0q0-64 64-64Z"
        p-id="6721"
        fill=""
      ></path>
      <path
        d="M576 448m64 0l256 0q64 0 64 64l0 0q0 64-64 64l-256 0q-64 0-64-64l0 0q0-64 64-64Z"
        p-id="6722"
        fill=""
      ></path>
      <path
        d="M576 256m64 0l256 0q64 0 64 64l0 0q0 64-64 64l-256 0q-64 0-64-64l0 0q0-64 64-64Z"
        p-id="6723"
        fill=""
      ></path>
      <path
        d="M64 640m64 0l768 0q64 0 64 64l0 0q0 64-64 64l-768 0q-64 0-64-64l0 0q0-64 64-64Z"
        p-id="6724"
        fill=""
      ></path>
    </svg>
  );
}
